import { AuthRedirector } from "@/app/AuthRedirector";
import { Outlet } from "react-router-dom";

export const AuthLayout = () => {
  return (
    <AuthRedirector>
      <Outlet />
    </AuthRedirector>
  );
};
